import { supabase } from '../supabaseClient';

const BUCKET_NAME = 'Lorzenspeicher';

export const supabaseStorageService = {
  // Datei hochladen mit Fortschritts-Tracking
  async uploadFile(file, folder = 'documents') {
    try {
      if (!supabase) {
        throw new Error('Supabase nicht konfiguriert');
      }

      // Dateinamen sicher machen (Sonderzeichen entfernen)
      const safeFileName = file.name
        .toLowerCase()
        .replace(/[^a-z0-9.-]/g, '_')
        .replace(/_+/g, '_');

      const filePath = `${folder}/${Date.now()}_${safeFileName}`;

      console.log('Uploading file to:', filePath);

      // Upload - einfacher ohne Callback, da Supabase JS SDK keinen Progress-Callback hat
      const { data, error } = await supabase.storage
        .from(BUCKET_NAME)
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) {
        console.error('Upload error:', error);
        throw new Error(`Upload fehlgeschlagen: ${error.message}`);
      }

      console.log('File uploaded successfully:', data);

      // Public URL generieren
      const { data: { publicUrl } } = supabase.storage
        .from(BUCKET_NAME)
        .getPublicUrl(filePath);

      console.log('Public URL:', publicUrl);

      return {
        success: true,
        filePath,
        publicUrl,
        fileName: file.name,
        fileSize: file.size,
        mimeType: file.type
      };
    } catch (error) {
      console.error('Storage upload error:', error);
      throw error;
    }
  },

  // Datei löschen
  async deleteFile(filePath) {
    try {
      if (!supabase) {
        throw new Error('Supabase nicht konfiguriert');
      }

      console.log('Deleting file:', filePath);

      const { error } = await supabase.storage
        .from(BUCKET_NAME)
        .remove([filePath]);

      if (error) {
        console.error('Delete error:', error);
        throw new Error(`Löschen fehlgeschlagen: ${error.message}`);
      }

      console.log('File deleted successfully');
      return { success: true };
    } catch (error) {
      console.error('Storage delete error:', error);
      throw error;
    }
  },

  // Datei-URL abrufen
  getFileUrl(filePath) {
    if (!supabase || !filePath) return null;
    
    const { data: { publicUrl } } = supabase.storage
      .from(BUCKET_NAME)
      .getPublicUrl(filePath);

    return publicUrl;
  },

  // Bucket-Informationen abrufen
  async getBucketInfo() {
    try {
      if (!supabase) {
        throw new Error('Supabase nicht konfiguriert');
      }

      const { data, error } = await supabase.storage
        .from(BUCKET_NAME)
        .list();

      if (error) {
        console.error('Bucket info error:', error);
        throw new Error(`Bucket-Info fehlgeschlagen: ${error.message}`);
      }

      return data;
    } catch (error) {
      console.error('Storage bucket info error:', error);
      throw error;
    }
  }
};